








































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import { getUser } from '@/utils/cookies'
// 公用组件
// api
import { addJurisdiction, editJurisdiction } from '@/pages/menu/api'
@Component({
  name: 'AddDialog',
  components: {
  }
})
export default class extends Vue {
  @Prop() private dialog!: any
  @Prop() private editdata!:{}
  private el: any = this.$refs
  private isDisable =false
  private userData={
    code: '',
    name: '',
    method: '',
    url: '',
    menuId: ''

  } as any
  private formRules = {
    code: [{ required: true, message: '请输入编码', trigger: 'blur' }],
    name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
    method: [{ required: true, message: '请输入请求方式', trigger: 'blur' }],
    url: [{ required: true, message: '请输入地址', trigger: 'blur' }]
  }
    @Watch('editdata')
    getUserData(val:any) {
      if (val.id !== undefined) this.userData = val
    }
  // 功能函数
  // 添加用户
  private async addSave() {
    const { data } = await addJurisdiction(this.userData)
    if (data.isSuccess) {
      this.$message({
        message: '操作成功！',
        type: 'success'
      })
      this.handleClose()
    }
  }
  // 编辑用户
  private async updateSave() {
    delete (this.userData as any).createTime
    delete (this.userData as any).updateTime
    const { data } = await editJurisdiction(this.userData)
    if (data.isSuccess) {
      this.$message({
        message: '操作成功！',
        type: 'success'
      })
      this.handleClose()
    }
  }

  // 表单提交
  private handleSubmit() {
    this.isDisable = true
    this.userData.menuId = (this.$parent as any).searchData.menuId
    setTimeout(() => {
      this.isDisable = false // 点击一次时隔两秒后才能再次点击
    }, 2000)
    ;(this.$refs.ruleForm as ElForm).validate(async(valid: boolean) => {
      if (valid) {
        if (this.dialog.type === 'add') {
          await this.addSave()
        } else {
          await this.updateSave()
        }
      } else {
        return false
      }
    })
  }
  // ui
  handleNodeClick(data:Object) {
  }
  // 表单取消
  private handleClose() {
    (this.$refs.ruleForm as ElForm).resetFields()
    this.$emit('close', (this.$parent as any).searchData.menuId)
  }
}
